import { render } from "./BlogArticle.vue?vue&type=template&id=1abc6b92"
import script from "./BlogArticle.vue?vue&type=script&lang=js"
export * from "./BlogArticle.vue?vue&type=script&lang=js"

import "./BlogArticle.vue?vue&type=style&index=0&id=1abc6b92&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__